import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-route",
  "use": "spr-route-usage",
  "viewBox": "0 0 46 46",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 46 46\" id=\"spr-route\"><defs><path id=\"spr-route_a\" d=\"M1070.82 86.82s-2.82-2.82-5.65 0l-18.35 18.36s-2.82 2.82 0 5.64l18.35 18.36s2.83 2.82 5.65 0l18.36-18.36s2.82-2.82 0-5.64z\" /><path id=\"spr-route_b\" d=\"M1065 114h-2v-5c0-2.2 1.8-3 3-3h5v-3l3 3 1 1-4 4v-3h-5c-.45.01-1 .2-1 1z\" /></defs><use fill=\"#95999c\" xlink:href=\"#spr-route_a\" transform=\"translate(-1045 -85)\" /><use fill=\"#fff\" xlink:href=\"#spr-route_b\" transform=\"translate(-1045 -85)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/route.svg
// module id = 282
// module chunks = 0